import template from '../../templates/Home/footer.template';
import Component from '../../core/component';

export default class Footer extends Component {
  constructor(data) {
    super(template, data);
  }
}
